import { themeVars } from '@styles/themes.css';
import { style } from '@vanilla-extract/css';

export const container = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  margin: '0 auto',
  width: '100%',
  gap: '0.75rem',
  '@media': {
    'screen and (max-width: 30em)': {
      paddingTop: '1rem',
    },
  },
});

export const previous = style({
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  marginLeft: '3.5%',
  marginRight: 'auto',
  fontSize: '1rem !important', // 16px
  fontFamily: themeVars.font.Roboto,
  color: '#000 !important',
  textDecoration: 'none !important',
});

export const label = style({
  marginLeft: '0.75rem', // 12px
  lineHeight: 1,
  selectors: {
    [`${previous}:hover &`]: {
      textDecoration: 'underline',
    },
  },
});

export const spacer = style({
  display: 'block',
  height: '2.5rem', // 40px
});

export const stepWrapper = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  margin: 'auto',
  width: '90%',
  gap: '1rem', // 16px
});
